var QuadRowPackageData = require('./quadRowPackageData.js');
var lib_core = require("lib-core");

var QfpData = function(position, angle, init) {
    QuadRowPackageData.apply(this, arguments);
};

lib_core.inherit(QfpData, QuadRowPackageData);
lib_core.JsonParser.registerClass(QfpData, "QfpData");

module.exports = QfpData;
